<h1 mat-dialog-title>Enviar notificações?</h1>
<div mat-dialog-content>
  Você está prestes a enviar notificações para os <b>{{ data.length }} examinadores selecionados</b>.<br /><br />

  <span *ngIf="hasExaminadoresNotificados()">Há examinadores que já foram notificados.<br /><br /></span>

  Deseja continuar?
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Enviar</button>
</div>
